<template>
  <div class="periodo-selector-wrapper">
    <v-menu
        v-model="menuAberto"
        :close-on-content-click="false"
        transition="scale-transition"
        :offset-y="!isMobile"
        :offset-x="false"
        :max-width="isMobile ? '95vw' : '600'"
        :min-width="isMobile ? '95vw' : '580'"
        :content-class="isMobile ? 'mobile-menu' : ''"
        :nudge-bottom="isMobile ? 0 : 10"
        :top="isMobile"
        :bottom="!isMobile"
        :attach="isMobile ? 'body' : false"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
            :value="displayPeriodo"
            :prepend-inner-icon="prependIcon"
            :placeholder="placeholder"
            readonly
            :dense="dense"
            :outlined="outlined"
            :hide-details="hideDetails"
            v-bind="attrs"
            v-on="on"
            :disabled="disabled"
            class="periodo-field"
            :clearable="clearable"
            @click:clear="limparDatas"
            :label="label"
        >
          <template v-slot:prepend-inner v-if="$scopedSlots['prepend-inner']">
            <slot name="prepend-inner" />
          </template>
          <template v-slot:append v-if="(dataInicio || dataFim) && showCheckIcon">
            <v-icon :color="checkIconColor">mdi-check-circle</v-icon>
          </template>
        </v-text-field>
      </template>

      <!-- Modal Compacto -->
      <v-card class="period-selector-card elevation-8" :class="{ 'mobile-card': isMobile }">
        <!-- Header Mobile -->
        <v-card-title v-if="isMobile" class="mobile-header">
          <div class="mobile-header-content">
            <v-icon color="white" small>mdi-calendar-range</v-icon>
            <span class="mobile-header-title">Selecionar Período</span>
          </div>
          <v-btn icon small color="white" @click="fecharModal">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <!-- Conteúdo -->
        <div class="period-content-compact" :class="{ 'mobile-content': isMobile }">
          <!-- Atalhos Laterais Compactos -->
          <div
              v-if="showShortcuts"
              class="shortcuts-sidebar"
              :class="{ 'mobile-sidebar': isMobile }"
          >
            <v-expansion-panels
                v-model="grupoExpandido"
                accordion
                flat
                class="shortcuts-accordion-compact"
            >
              <!-- Períodos -->
              <v-expansion-panel v-if="shortcuts.includes('periods')" class="panel-compact">
                <v-expansion-panel-header class="panel-header-compact">
                  <div class="panel-title">
                    <v-icon x-small color="primary">mdi-calendar-clock</v-icon>
                    <span>Períodos</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-content-compact">
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('today')">
                    <v-icon x-small left>mdi-calendar-today</v-icon>
                    Hoje
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('yesterday')">
                    <v-icon x-small left>mdi-calendar-minus</v-icon>
                    Ontem
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('week')">
                    <v-icon x-small left>mdi-calendar-week</v-icon>
                    Últimos 7 dias
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('month')">
                    <v-icon x-small left>mdi-calendar-month</v-icon>
                    Últimos 30 dias
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Semanas -->
              <v-expansion-panel v-if="shortcuts.includes('weeks')" class="panel-compact">
                <v-expansion-panel-header class="panel-header-compact">
                  <div class="panel-title">
                    <v-icon x-small color="primary">mdi-calendar-week</v-icon>
                    <span>Semanas</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-content-compact">
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('currentWeek')">
                    <v-icon x-small left>mdi-calendar-cursor</v-icon>
                    Semana Atual
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('lastWeek')">
                    <v-icon x-small left>mdi-calendar-arrow-left</v-icon>
                    Semana Passada
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Meses -->
              <v-expansion-panel v-if="shortcuts.includes('months')" class="panel-compact">
                <v-expansion-panel-header class="panel-header-compact">
                  <div class="panel-title">
                    <v-icon x-small color="primary">mdi-calendar-month</v-icon>
                    <span>Meses</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-content-compact">
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('currentMonth')">
                    <v-icon x-small left>mdi-calendar-month-outline</v-icon>
                    Mês Atual
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('lastMonth')">
                    <v-icon x-small left>mdi-calendar-arrow-left</v-icon>
                    Mês Passado
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('last60days')">
                    <v-icon x-small left>mdi-calendar-range</v-icon>
                    Últimos 60 dias
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('last90days')">
                    <v-icon x-small left>mdi-calendar-range</v-icon>
                    Últimos 90 dias
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Trimestres -->
              <v-expansion-panel v-if="shortcuts.includes('quarters')" class="panel-compact">
                <v-expansion-panel-header class="panel-header-compact">
                  <div class="panel-title">
                    <v-icon x-small color="primary">mdi-calendar-multiple</v-icon>
                    <span>Trimestres</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-content-compact">
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('currentQuarter')">
                    <v-icon x-small left>mdi-calendar-multiple</v-icon>
                    Trimestre Atual
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('lastQuarter')">
                    <v-icon x-small left>mdi-calendar-arrow-left</v-icon>
                    Trimestre Passado
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Anos -->
              <v-expansion-panel v-if="shortcuts.includes('years')" class="panel-compact">
                <v-expansion-panel-header class="panel-header-compact">
                  <div class="panel-title">
                    <v-icon x-small color="primary">mdi-calendar</v-icon>
                    <span>Anos</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-content-compact">
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('currentYear')">
                    <v-icon x-small left>mdi-calendar</v-icon>
                    Ano Atual
                  </v-btn>
                  <v-btn x-small block text class="btn-compact" @click="aplicarAtalho('lastYear')">
                    <v-icon x-small left>mdi-calendar-arrow-left</v-icon>
                    Ano Passado
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>

              <!-- Atalhos Personalizados -->
              <v-expansion-panel v-if="customShortcuts.length > 0" class="panel-compact">
                <v-expansion-panel-header class="panel-header-compact">
                  <div class="panel-title">
                    <v-icon x-small color="primary">mdi-star</v-icon>
                    <span>Personalizados</span>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="panel-content-compact">
                  <v-btn
                      v-for="shortcut in customShortcuts"
                      :key="shortcut.key"
                      x-small
                      block
                      text
                      class="btn-compact"
                      @click="aplicarAtalhoPersonalizado(shortcut)"
                  >
                    <v-icon x-small left>{{ shortcut.icon || 'mdi-calendar' }}</v-icon>
                    {{ shortcut.label }}
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </div>

          <!-- Calendário Único -->
          <div class="calendar-area" :class="{ 'full-width': !showShortcuts }">
            <!-- Container do Calendário -->
            <div class="calendar-container">
              <v-date-picker
                  v-model="rangeLocal"
                  locale="pt-BR"
                  :color="pickerColor"
                  range
                  :max="maxDate"
                  :min="minDate"
                  :picker-date.sync="pickerDate"
                  no-title
                  full-width
                  class="calendar-single"
                  :class="{ 'mobile-calendar': isMobile }"
              ></v-date-picker>
            </div>

            <!-- Dica de uso -->
            <div v-if="showHint && !isMobile" class="calendar-hint">
              <v-icon x-small color="grey">mdi-information-outline</v-icon>
              <span>{{ hintText }}</span>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <!-- Footer Compacto Simplificado -->
        <v-card-actions class="footer-compact">
          <!-- Informação do período selecionado -->
          <div class="period-info" v-if="rangeLocal && rangeLocal.length > 0">
            <span class="period-text">
              {{ formatarData(rangeLocal[0]) }}
              <v-icon x-small color="grey" class="mx-1">mdi-arrow-right</v-icon>
              {{ formatarData(rangeLocal[1] || rangeLocal[0]) }}
            </span>
            <v-chip x-small :color="chipColor" outlined class="ml-2">
              {{ diasSelecionados }}d
            </v-chip>
          </div>
          <div v-else class="period-info-empty">
            <span class="period-text-empty">Nenhum período selecionado</span>
          </div>

          <v-spacer></v-spacer>

          <!-- Botões de ação -->
          <v-btn
              v-if="showClearButton"
              x-small
              text
              color="error"
              @click="limparDatas"
              :disabled="!rangeLocal || rangeLocal.length === 0"
          >
            <v-icon left x-small>mdi-close-circle</v-icon>
            {{ clearButtonText }}
          </v-btn>
          <v-btn
              x-small
              :color="applyButtonColor"
              depressed
              @click="aplicar"
              :disabled="!rangeLocal || rangeLocal.length === 0"
          >
            <v-icon left x-small>mdi-check</v-icon>
            {{ applyButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  name: 'SeletorPeriodo',

  props: {
    value: {
      type: Object,
      default: () => ({ inicio: null, fim: null })
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Selecione o período'
    },
    prependIcon: {
      type: String,
      default: 'mdi-calendar-range'
    },
    dense: {
      type: Boolean,
      default: true
    },
    outlined: {
      type: Boolean,
      default: true
    },
    hideDetails: {
      type: [Boolean, String],
      default: true
    },
    clearable: {
      type: Boolean,
      default: true
    },
    showCheckIcon: {
      type: Boolean,
      default: true
    },
    checkIconColor: {
      type: String,
      default: 'success'
    },
    maxDate: {
      type: String,
      default: () => new Date().toISOString().split('T')[0]
    },
    minDate: {
      type: String,
      default: null
    },
    pickerColor: {
      type: String,
      default: 'primary'
    },
    showShortcuts: {
      type: Boolean,
      default: true
    },
    shortcuts: {
      type: Array,
      default: () => ['periods', 'weeks', 'months', 'quarters', 'years']
    },
    customShortcuts: {
      type: Array,
      default: () => []
    },
    showHint: {
      type: Boolean,
      default: true
    },
    hintText: {
      type: String,
      default: 'Clique em duas datas para selecionar um período'
    },
    showClearButton: {
      type: Boolean,
      default: true
    },
    clearButtonText: {
      type: String,
      default: 'Limpar'
    },
    applyButtonText: {
      type: String,
      default: 'Aplicar'
    },
    applyButtonColor: {
      type: String,
      default: 'primary'
    },
    chipColor: {
      type: String,
      default: 'primary'
    },
    dateFormat: {
      type: String,
      default: 'DD/MM/YYYY',
      validator: (value) => ['DD/MM/YYYY', 'MM/DD/YYYY', 'YYYY-MM-DD'].includes(value)
    },
    autoApply: {
      type: Boolean,
      default: false
    },
    closeOnApply: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      menuAberto: false,
      rangeLocal: [],
      grupoExpandido: 0,
      windowWidth: window.innerWidth,
      pickerDate: null // Controla o mês exibido no calendário
    };
  },

  computed: {
    isMobile() {
      return this.windowWidth < 960;
    },

    dataInicio() {
      return this.value?.inicio || null;
    },

    dataFim() {
      return this.value?.fim || null;
    },

    displayPeriodo() {
      if (!this.dataInicio && !this.dataFim) return '';
      if (this.dataInicio && this.dataFim) {
        return `${this.formatarData(this.dataInicio)} até ${this.formatarData(this.dataFim)}`;
      }
      if (this.dataInicio) return `A partir de ${this.formatarData(this.dataInicio)}`;
      return `Até ${this.formatarData(this.dataFim)}`;
    },

    diasSelecionados() {
      if (!this.rangeLocal || this.rangeLocal.length === 0) return 0;
      const inicio = new Date(this.rangeLocal[0]);
      const fim = new Date(this.rangeLocal[1] || this.rangeLocal[0]);
      const diffTime = Math.abs(fim - inicio);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
      return diffDays;
    }
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },

  watch: {
    value: {
      handler(newVal) {
        if (newVal && (newVal.inicio || newVal.fim)) {
          const datas = [];
          if (newVal.inicio) datas.push(newVal.inicio);
          if (newVal.fim && newVal.fim !== newVal.inicio) datas.push(newVal.fim);
          this.rangeLocal = datas.sort();

          // Navega para o mês da data inicial
          if (newVal.inicio) {
            this.navegarParaData(newVal.inicio);
          }
        } else {
          this.rangeLocal = [];
        }
      },
      deep: true,
      immediate: true
    },

    menuAberto(val) {
      if (val) {
        const datas = [];
        if (this.dataInicio) datas.push(this.dataInicio);
        if (this.dataFim && this.dataFim !== this.dataInicio) datas.push(this.dataFim);
        this.rangeLocal = datas.sort();
        this.grupoExpandido = 0;

        // Define o mês a ser exibido ao abrir
        if (this.dataInicio) {
          this.navegarParaData(this.dataInicio);
        } else {
          // Se não houver data selecionada, mostra o mês atual
          const hoje = new Date();
          this.pickerDate = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
        }

        // Previne scroll do body quando modal está aberto no mobile
        if (this.isMobile) {
          document.body.style.overflow = 'hidden';
        }
      } else {
        // Restaura scroll do body
        if (this.isMobile) {
          document.body.style.overflow = '';
        }
      }
    },

    rangeLocal: {
      handler(newVal) {
        if (this.autoApply && newVal && newVal.length === 2) {
          this.aplicar();
        }
      },
      deep: true
    }
  },

  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth;
    },

    formatarData(data) {
      if (!data) return '';
      const [ano, mes, dia] = data.split('-');

      switch (this.dateFormat) {
        case 'MM/DD/YYYY':
          return `${mes}/${dia}/${ano}`;
        case 'YYYY-MM-DD':
          return data;
        case 'DD/MM/YYYY':
        default:
          return `${dia}/${mes}/${ano}`;
      }
    },

    navegarParaData(dataStr) {
      // Navega o calendário para o mês da data fornecida
      if (!dataStr) return;

      const [ano, mes] = dataStr.split('-');
      this.pickerDate = `${ano}-${mes}`;
    },

    aplicarAtalho(periodo) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);
      let inicio = new Date(hoje);
      let fim = new Date(hoje);

      switch (periodo) {
        case 'today':
          break;
        case 'yesterday':
          inicio.setDate(inicio.getDate() - 1);
          fim.setDate(fim.getDate() - 1);
          break;
        case 'week':
          inicio.setDate(inicio.getDate() - 6);
          break;
        case 'month':
          inicio.setDate(inicio.getDate() - 29);
          break;
        case 'last60days':
          inicio.setDate(inicio.getDate() - 59);
          break;
        case 'last90days':
          inicio.setDate(inicio.getDate() - 89);
          break;
        case 'currentWeek':
          inicio = this.getInicioSemana(hoje);
          fim = this.getFimSemana(hoje);
          break;
        case 'lastWeek': {
          const semanaPassada = new Date(hoje);
          semanaPassada.setDate(semanaPassada.getDate() - 7);
          inicio = this.getInicioSemana(semanaPassada);
          fim = this.getFimSemana(semanaPassada);
          break;
        }
        case 'currentMonth':
          inicio = this.getInicioMes(hoje);
          fim = this.getFimMes(hoje);
          break;
        case 'lastMonth': {
          const mesPassado = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
          inicio = this.getInicioMes(mesPassado);
          fim = this.getFimMes(mesPassado);
          break;
        }
        case 'currentQuarter':
          inicio = this.getInicioTrimestre(hoje);
          fim = this.getFimTrimestre(hoje);
          break;
        case 'lastQuarter': {
          const trimestrePassado = new Date(hoje);
          trimestrePassado.setMonth(trimestrePassado.getMonth() - 3);
          inicio = this.getInicioTrimestre(trimestrePassado);
          fim = this.getFimTrimestre(trimestrePassado);
          break;
        }
        case 'currentYear':
          inicio = new Date(hoje.getFullYear(), 0, 1);
          fim = new Date(hoje.getFullYear(), 11, 31);
          break;
        case 'lastYear':
          inicio = new Date(hoje.getFullYear() - 1, 0, 1);
          fim = new Date(hoje.getFullYear() - 1, 11, 31);
          break;
      }

      const inicioStr = inicio.toISOString().split('T')[0];
      const fimStr = fim.toISOString().split('T')[0];

      this.rangeLocal = [inicioStr, fimStr].sort();

      // Navega o calendário para o mês da data inicial
      this.navegarParaData(inicioStr);
    },

    aplicarAtalhoPersonalizado(shortcut) {
      const hoje = new Date();
      hoje.setHours(0, 0, 0, 0);

      let inicio, fim;

      if (shortcut.days) {
        inicio = new Date(hoje);
        inicio.setDate(inicio.getDate() - (shortcut.days - 1));
        fim = new Date(hoje);
      } else if (shortcut.range) {
        inicio = shortcut.range.inicio;
        fim = shortcut.range.fim;
      } else if (shortcut.callback) {
        const result = shortcut.callback();
        inicio = result.inicio;
        fim = result.fim;
      }

      if (inicio && fim) {
        const inicioStr = inicio instanceof Date ? inicio.toISOString().split('T')[0] : inicio;
        const fimStr = fim instanceof Date ? fim.toISOString().split('T')[0] : fim;
        this.rangeLocal = [inicioStr, fimStr].sort();

        // Navega o calendário para o mês da data inicial
        this.navegarParaData(inicioStr);
      }
    },

    getInicioSemana(data) {
      const d = new Date(data);
      const dia = d.getDay();
      const diff = d.getDate() - dia;
      return new Date(d.setDate(diff));
    },

    getFimSemana(data) {
      const d = new Date(data);
      const dia = d.getDay();
      const diff = d.getDate() + (6 - dia);
      return new Date(d.setDate(diff));
    },

    getInicioMes(data) {
      return new Date(data.getFullYear(), data.getMonth(), 1);
    },

    getFimMes(data) {
      return new Date(data.getFullYear(), data.getMonth() + 1, 0);
    },

    getTrimestre(data) {
      return Math.floor(data.getMonth() / 3);
    },

    getInicioTrimestre(data) {
      const trimestre = this.getTrimestre(data);
      return new Date(data.getFullYear(), trimestre * 3, 1);
    },

    getFimTrimestre(data) {
      const trimestre = this.getTrimestre(data);
      return new Date(data.getFullYear(), trimestre * 3 + 3, 0);
    },

    limparDatas() {
      this.rangeLocal = [];
      this.$emit('input', { inicio: null, fim: null });
      this.$emit('change', { inicio: null, fim: null });
      this.$emit('clear');

      // Volta para o mês atual ao limpar
      const hoje = new Date();
      this.pickerDate = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`;
    },

    aplicar() {
      const sortedRange = [...this.rangeLocal].sort();
      const periodo = {
        inicio: sortedRange[0] || null,
        fim: sortedRange[1] || sortedRange[0] || null
      };
      this.$emit('input', periodo);
      this.$emit('change', periodo);
      this.$emit('apply', periodo);

      if (this.closeOnApply) {
        this.fecharModal();
      }
    },

    fecharModal() {
      this.menuAberto = false;
    }
  }
};
</script>

<style scoped>
.periodo-selector-wrapper {
  width: 100%;
}

/* ===== INPUT ===== */
.periodo-field >>> .v-input__control {
  min-height: 44px !important;
}

.periodo-field >>> fieldset {
  border-color: #cbd5e1;
  border-width: 2px;
  transition: all 0.2s ease;
}

.periodo-field >>> .v-input__slot {
  background: #f8fafc;
  transition: all 0.2s ease;
  border-radius: 10px;
}

.periodo-field >>> .v-input__prepend-inner .v-icon,
.periodo-field >>> .v-input__append .v-icon {
  color: #023449 !important;
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.periodo-field:hover >>> .v-input__prepend-inner .v-icon,
.periodo-field:hover >>> .v-input__append .v-icon {
  opacity: 1 !important;
}

.periodo-field >>> .v-input__slot:hover {
  background: #ffffff;
}

.periodo-field >>> .v-input__slot:hover fieldset {
  border-color: #023449;
}

.periodo-field >>> .v-input--is-focused fieldset {
  border-color: #023449 !important;
  border-width: 2px;
  box-shadow: 0 0 0 3px rgba(2, 52, 73, 0.1);
}

.periodo-field >>> .v-input--is-focused .v-input__slot {
  background: #ffffff !important;
}

/* ===== MODAL ===== */
.period-selector-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(2, 52, 73, 0.15) !important;
  max-width: 580px;
}

.mobile-card {
  max-width: 95vw !important;
  width: 95vw !important;
  max-height: 85vh !important;
  display: flex;
  flex-direction: column;
}

/* ===== HEADER MOBILE ===== */
.mobile-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: linear-gradient(135deg, #023449 0%, #035a7a 100%);
  color: white;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.2);
  flex-shrink: 0;
}

.mobile-header-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mobile-header-title {
  font-size: 0.875rem;
  font-weight: 700;
  letter-spacing: 0.3px;
}

/* Conteúdo */
.period-content-compact {
  display: flex;
  min-height: 340px;
  height: auto;
}

.mobile-content {
  flex-direction: column;
  height: auto;
  max-height: calc(85vh - 100px);
  min-height: 0;
  flex: 1;
  overflow: hidden;
}

/* Sidebar de Atalhos */
.shortcuts-sidebar {
  width: 180px;
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 100%);
  border-right: 1px solid #e2e8f0;
  overflow-y: auto;
  padding: 8px;
}

.mobile-sidebar {
  width: 100%;
  max-height: 35vh;
  min-height: 220px;
  border-right: none;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
}

.shortcuts-accordion-compact {
  background: transparent !important;
}

.panel-compact {
  background: transparent !important;
  margin-bottom: 2px !important;
}

.panel-compact::before {
  box-shadow: none !important;
}

.panel-header-compact {
  min-height: 30px !important;
  padding: 0 6px !important;
  background: rgba(2, 52, 73, 0.04) !important;
  border-radius: 6px !important;
  transition: all 0.2s ease;
}

.panel-header-compact:hover {
  background: rgba(2, 52, 73, 0.08) !important;
}

.panel-header-compact >>> .v-expansion-panel-header__icon {
  margin-left: 2px;
}

.panel-header-compact >>> .v-expansion-panel-header__icon .v-icon {
  font-size: 14px !important;
  color: #023449 !important;
}

.panel-title {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 0.688rem;
  font-weight: 700;
  color: #023449;
}

.panel-content-compact {
  padding: 0 !important;
}

.panel-content-compact >>> .v-expansion-panel-content__wrap {
  padding: 2px 0 4px 0 !important;
}

.btn-compact {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 0.688rem !important;
  justify-content: flex-start !important;
  margin-bottom: 1px;
  border-radius: 5px;
  transition: all 0.2s ease;
  color: #023449 !important;
  height: 24px !important;
  padding: 0 8px !important;
  letter-spacing: 0;
}

.btn-compact:hover {
  background-color: rgba(2, 52, 73, 0.1) !important;
  transform: translateX(3px);
}

.btn-compact >>> .v-icon {
  margin-right: 5px !important;
}

/* Área do Calendário */
.calendar-area {
  flex: 1;
  padding: 10px;
  background: #ffffff;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
}

.calendar-area.full-width {
  max-width: 100%;
}

/* Container do Calendário */
.calendar-container {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 0;
}

.calendar-single {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08) !important;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  overflow: hidden;
  max-width: 100%;
  width: 100%;
}

/* ===== HEADER DO CALENDÁRIO - COMPACTO ===== */
.calendar-single >>> .v-date-picker-header {
  background: #023449 !important;
  color: white !important;
  padding: 6px !important;
  min-height: 36px !important;
}

.calendar-single >>> .v-date-picker-header__value {
  flex: 1;
  margin: 0 !important;
}

.calendar-single >>> .v-date-picker-header__value button {
  color: white !important;
  font-weight: 700 !important;
  font-size: 0.813rem !important;
}

.calendar-single >>> .v-date-picker-header .v-btn {
  width: 26px !important;
  height: 26px !important;
  color: white !important;
}

/* ===== TABELA DO CALENDÁRIO - COMPACTA ===== */
.calendar-single >>> .v-date-picker-table {
  height: auto !important;
  padding: 4px !important;
}

.calendar-single >>> .v-date-picker-table thead {
  height: 24px !important;
}

.calendar-single >>> .v-date-picker-table thead th {
  font-size: 0.625rem !important;
  padding: 2px !important;
  color: #64748b;
  font-weight: 700;
  height: 24px !important;
}

.calendar-single >>> .v-date-picker-table--date tbody {
  height: auto !important;
}

.calendar-single >>> .v-date-picker-table--date tbody tr {
  height: 28px !important;
}

.calendar-single >>> .v-date-picker-table--date td {
  padding: 1px !important;
  height: 28px !important;
}

.calendar-single >>> .v-date-picker-table--date .v-btn {
  width: 28px !important;
  height: 28px !important;
  font-size: 0.75rem !important;
  transition: all 0.2s ease;
  border-radius: 6px;
  font-weight: 500;
  margin: 0 !important;
}

/* ===== RANGE STYLING ===== */
.calendar-single >>> .v-date-picker-table--date .v-btn.v-btn--active {
  background: #023449 !important;
  color: white !important;
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(2, 52, 73, 0.3);
  z-index: 2;
  position: relative;
  transform: scale(1.05);
}

.calendar-single >>> .v-date-picker-table--date .v-date-picker-table__current {
  background: rgba(96, 165, 250, 0.15) !important;
  color: #023449 !important;
  font-weight: 600;
}

.calendar-single >>> .v-date-picker-table--date .v-btn.v-btn--active:hover {
  transform: scale(1.08);
  box-shadow: 0 3px 8px rgba(2, 52, 73, 0.4);
}

.calendar-single >>> .v-date-picker-table--date .v-btn:not(.v-btn--active):hover {
  background: rgba(2, 52, 73, 0.08) !important;
  transform: scale(1.05);
}

.calendar-single >>> .v-date-picker-table--date .v-btn.v-btn--outlined {
  border: 2px solid #023449 !important;
  font-weight: 700 !important;
}

/* Dica de uso */
.calendar-hint {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  font-size: 0.625rem;
  color: #64748b;
  font-style: italic;
  padding: 4px;
  background: #f8fafc;
  border-radius: 6px;
  flex-shrink: 0;
}

/* Footer Simplificado */
.footer-compact {
  padding: 8px 12px !important;
  background: #f8fafc;
  border-top: 1px solid #e2e8f0;
  min-height: 44px !important;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.period-info {
  display: flex;
  align-items: center;
  gap: 4px;
}

.period-text {
  font-size: 0.75rem;
  font-weight: 600;
  color: #023449;
  display: flex;
  align-items: center;
}

.period-info-empty {
  display: flex;
  align-items: center;
}

.period-text-empty {
  font-size: 0.688rem;
  color: #94a3b8;
  font-style: italic;
}

.footer-compact .v-btn {
  text-transform: none;
  font-weight: 600;
  letter-spacing: 0;
  border-radius: 6px;
  font-size: 0.688rem;
  height: 28px !important;
  padding: 0 12px !important;
}

/* Botão Aplicar com cor fixa */
.footer-compact .v-btn.primary {
  background-color: #023449 !important;
  color: #ffffff !important;
  box-shadow: 0 2px 8px rgba(2, 52, 73, 0.2);
  transition: all 0.2s ease;
}

.footer-compact .v-btn.primary:hover:not(.v-btn--disabled) {
  background-color: #035a7a !important;
  box-shadow: 0 4px 12px rgba(2, 52, 73, 0.3);
  transform: translateY(-1px);
}

.footer-compact .v-btn.primary >>> .v-btn__content {
  color: #ffffff !important;
}

.footer-compact .v-btn.primary >>> .v-icon {
  color: #ffffff !important;
}

/* Scrollbar */
.shortcuts-sidebar::-webkit-scrollbar,
.calendar-area::-webkit-scrollbar {
  width: 3px;
}

.shortcuts-sidebar::-webkit-scrollbar-track,
.calendar-area::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.shortcuts-sidebar::-webkit-scrollbar-thumb,
.calendar-area::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 2px;
}

.shortcuts-sidebar::-webkit-scrollbar-thumb:hover,
.calendar-area::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Menu Mobile */
.mobile-menu {
  position: fixed !important;
  left: 50% !important;
  top: 50% !important;
  transform: translate(-50%, -50%) !important;
  margin: 0 !important;
  max-width: 95vw !important;
  max-height: 85vh !important;
}

/* Responsividade Tablet */
@media (max-width: 960px) and (min-width: 600px) {
  .period-content-compact {
    min-height: 360px;
  }

  .shortcuts-sidebar {
    width: 160px;
  }

  .calendar-single >>> .v-date-picker-table--date .v-btn {
    width: 30px !important;
    height: 30px !important;
  }
}

/* Responsividade Mobile */
@media (max-width: 599px) {
  .mobile-header {
    padding: 8px 10px;
  }

  .mobile-header-title {
    font-size: 0.813rem;
  }

  .mobile-sidebar {
    max-height: 38vh;
    min-height: 240px;
  }

  .calendar-area {
    padding: 8px;
  }

  .calendar-single >>> .v-date-picker-table--date .v-btn {
    width: 26px !important;
    height: 26px !important;
    font-size: 0.688rem !important;
  }

  .footer-compact {
    padding: 6px 10px !important;
  }

  .period-text {
    font-size: 0.688rem;
  }

  .footer-compact .v-btn {
    font-size: 0.625rem;
    height: 26px !important;
    padding: 0 10px !important;
  }
}

/* Landscape Mobile */
@media (max-width: 960px) and (orientation: landscape) {
  .mobile-content {
    max-height: 80vh;
  }

  .mobile-sidebar {
    max-height: 30vh;
    min-height: 180px;
  }
}

/* Telas muito pequenas */
@media (max-width: 360px) {
  .mobile-sidebar {
    max-height: 35vh;
    min-height: 200px;
  }

  .btn-compact {
    font-size: 0.625rem !important;
    height: 22px !important;
  }

  .calendar-single >>> .v-date-picker-table--date .v-btn {
    width: 24px !important;
    height: 24px !important;
    font-size: 0.625rem !important;
  }
}

/* Acessibilidade */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
